export enum OrderFlowType {
  Internet = 'Internet',
  Wireless = 'Wireless',
  Video = 'Video'
  // Add other flow types as needed
}
